<ion-header>
    <ion-toolbar color="gallaghergreen">
      <img (click)="navigateToBaseLogin()" class="gallagher-logo" [src]="'./assets/images/Gallagher Logo -White Transparent.png'" />
    </ion-toolbar>
</ion-header>
    <div class="loading-container"  *ngIf="!loaded">
        <ion-spinner></ion-spinner>
    </div>
<ion-content class="login-content">
  <div class="parent-container">
    <ion-card [ngClass]="{'larger-width': authService.isNative}">
        <ion-card-header>
            <div>
                <span class="login-title">Forgot Password</span>
            </div>
        </ion-card-header>
        <ion-grid>
          <div>
            <ion-row>
              <ion-col>
                <ion-label>Email *</ion-label>
                <ion-input type="text" [(ngModel)]="email" placeholder="Enter your email" class="ion-text-left color-light user-id"></ion-input>
              </ion-col>
            </ion-row>
          </div>

          <ion-row>
            <ion-col>
                <ion-button color="gallaghergreen" class="btn-box-shadow submit-button" [disabled]="!email" (click)="submit()">Submit</ion-button>
            </ion-col>
          </ion-row>
           <ion-row class="garment-label-button">
              <ion-col class="register-text">
                <span (click)="navigateToBack()" class="back-btn">
                  <ion-icon name="arrow-back-outline"></ion-icon>
                  Back
                </span>
              </ion-col>
              <ion-col></ion-col>
            </ion-row>
        </ion-grid>
      </ion-card>
  </div>
</ion-content>